module.exports = __webpack_public_path__ + "img/1382157962.855c0b8f.jpg";